import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Link } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import moment from 'moment';

export default function ProjectGroupDialog({ handleGroupDialogCallback }) {
	const [refresh, setRefresh] = React.useState(true);
	const [open, setOpen] = React.useState(false);


	const initialValues = {
		projectGroup: ''
	};

	const validFormSchema = Yup.object({
		projectGroup: Yup
			.string('Enter a  project group name')
			.required(' project group name is required')
	})

	const onTrigger = React.useCallback((values) => {
		const msg = {
			ProjectGroup: values.projectGroup
		};

		handleGroupDialogCallback(msg);
		handleClose();
	})

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};


	return (
		<div>
			<Button variant="contained" onClick={handleClickOpen}>
				Add Project Group
			</Button>
			<Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
				<DialogContent>
					<Formik
						initialValues={initialValues}
						validationSchema={validFormSchema}
						onSubmit={(values, { resetForm }) => {
							onTrigger(values);
							resetForm();
						}}
					>
						{props => (
							<Form>
								<AppBar sx={{ position: 'relative' }}>
									<Toolbar>
										<IconButton
											edge="start"
											color="inherit"
											onClick={handleClose}
											aria-label="close"
										>
											<CloseIcon />
										</IconButton>
										<Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
											Project Group
										</Typography>
										<Button autoFocus color="inherit" onClick={props.handleSubmit}>
											save
										</Button>
									</Toolbar>
								</AppBar>
								<DialogTitle>Project Group Info:</DialogTitle>
								<div>
									<FormControl sx={{ m: 1, width: 240 }}>
										<TextField
											name="projectGroup"
											id="outlined-project"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.projectGroup}
											error={props.touched.projectGroup && Boolean(props.errors.projectGroup)}
											helperText={props.touched.projectGroup && props.errors.projectGroup}
											label="Project Group"
										/>
									</FormControl>
								</div>
							</Form>
						)}
					</Formik>
				</DialogContent>
			</Dialog>
		</div>
	);
}